import gcu from './en/gcu'
import legacynotice from './en/legacy_notice'

export default {
  onlinepage: {
    message:
      'This part of the application is not compatible with compact screens. Please switch to a computer for more comfort',
  },
  request: {
    user: {
      notfound: 'User not found',
    },
    lineid: {
      notfound: 'Line id not found',
    },
    stakeholder: {
      notfound: 'Stakeholder not found',
      deactivate: 'This stakeholder is disabled',
    },
    roaming_team: {
      notfound: 'Roaming team not found',
    },
    site: {
      notfound: 'Control site not found',
    },
    venue: {
      notFound: 'Venue not found',
      codeNotUnique: 'The code entered already exists for another venue.',
    },
    equipmentType: {
      notFound: 'Equipment type not found',
      codeNotUnique: 'The code you entered is already used for another equipment type.'
    }
  },
  validations: {
    required: 'This field is required.',
    minValue: 'Value must be greater than {min}.',
    minLength: 'This field must contain at least {min} characters.',
    maxLength: 'This field must contain at most {max} characters.',
    email: 'Invalid email address.',
    sameAsEmail: 'Email address and its confirmation must be the same.',
    sameAsPassword: 'Password and its confirmation must be the same.',
    passwordPattern:
      'The password must be between 8 and 30 characters and contain at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character',
    passwordSpecialCharacter: 'Special characters accepted',
    numberArrayPattern: 'The list must contain only integers.',
    phoneNumberPattern: 'The phone number entered is invalid.',
    appointmentEndTimeGreaterThan: 'End time must be greater than start time',
    isAfterDate: 'The end date must be later than the start date.',
    captchaanswer: {
      empty: 'Answer is invalid.',
      invalid: 'Answer is invalid.',
    },
    error_exeption:
      'Your login information is invalid. Please verify that you have created an account and activated it via the activation email sent to your registration.',

    login: {
      credentials: 'Invalid email or password.',
      locked: 'You account is locked.',
      email: {
        empty: 'Email address is invalid.',
      },
      password: {
        empty: 'Password should not be empty.',
      },
      failed: 'Email address or password invalid. You may need to change password',
      notapproved: 'Your account is being approved. You cannot access the application at the moment.',
      refused: 'Your account request has been rejected. You cannot access the application'
    },
    register: {
      password: {
        empty: 'Password should not be empty.',
      },
      email: {
        empty: 'Email address should not be empty.',
        exists: 'Email address already exists for another account.',
      },
      captchaanswer: {
        empty: 'The answer  is invalid',
        invalid: 'The answer is invalid',
      },
      firstname: {
        empty: 'Firstname should not be empty.',
        letters: 'Firstname should only contain letters',
      },
      lastname: {
        empty: 'Lastname should not be empty.',
        letters: 'Lastname should only contain letters',
      },
      stakeholderId: {
        empty: 'Stakeholder should not be empty.',
        deactivate: 'This stakeholder is disabled',
      },
      company: {
        empty: 'Company should not be empty.',
      },
    },
    user: {
      delete: {
        appointment: 'The user has associated appointments',
      },
      validation: {
        email: {
          exists: 'An account already exists with this email address.',
        },
      },
      update: {
        admin: 'An agent cannot set a user as administrator.',
      },
      admin: {
        role: "An administrator can't change his rights.",
      },
      yubekey: {
        exists: 'An account already exists with this yubekey',
      },
      agent: {
        not_approved: 'The email address is associated with a contact account not approved.'
      }
    },
    delete: {
      appointment: 'The user has associated appointments',
      appointmentpast: 'One or more appointment have already passed.',
      stakeholder:
        'The stakeholder has a frequency assignment or a linked contact !',
    },
    change: {
      password: {
        invalidToken: 'Change password token is invalid',
        invalid: 'The passwords are not identical.',
        format:
          'The password must contain at least 8 characters with 1 upper case, 1 lower case, 1 number and 1 special character. (maximum 30 characters)',
      },
      captchaanswer: {
        empty: 'The answer  is invalid',
        invalid: 'The answer is invalid',
      },
    },
    userId: {
      invalid: 'Invalid user id',
    },
    activation: {
      alreadyactivated: 'The user is already activated.',
      activationCode: {
        invalid: 'Invalid activation code.',
      },
    },
    request: {
      user: {
        empty: 'User should not be empty',
        invalidrole: 'The user must be a contact',
      },
      totaltime: {
        invalid: 'Total time does not match selected equipments',
        specialRequest: 'The request is special'
      },
      stakeholderlocked: 'This stakeholder is disabled',
    },
    appointment: {
      conflict: 'A selected time appointment is not available anymore',
      wrongsite: 'The selected site does not match the configured single control site',
      multipleOf5Min: 'Appointment duration must be a multiple of 5 minutes',
      overlap: 'This appointment includes times that are not available',
      exceedsControlDuration:
        'Appointment duration exceeds estimated control duration',
      greaterThan0: 'Appointment duration must be greater than 0',
      appointment: {
        empty: 'Appointment should not be empty',
      },
      start: {
        empty: 'Start date should not be empty',
        passed: 'Start date should not be passed',
      },
      end: {
        empty: 'End date should not be empty',
        invalid: 'End date is invalid',
      },
      duration: {
        toolong: 'Time appointment must be less than 3 hours',
      },
      site: {
        disabled: 'The site is not open',
      }
    },
    office: {
      name: {
        empty: 'Name should not be empty.',
      },
      site: {
        empty: 'Site should not be empty.',
      },
      planning: {
        empty: 'The desk should have a planning.',
      },
      openDate: {
        empty: 'The desk should have an open date.',
      },
      closeDate: {
        empty: 'The desk should have a close date.',
      },
      dates: {
        invalid: 'Open dates are invalid.',
      },
    },
    dayplanning: {
      morningopen: {
        empty: 'Morning open time should not be empty.',
      },
      morningclose: {
        empty: 'Morning close time should not be empty.',
      },
      afternoonopen: {
        empty: 'Afternoon open time should not be empty.',
      },
      afternoonclose: {
        empty: 'Afternoon close time should not be empty.',
      },
      hours: {
        invalid: 'Planning is invalid.',
      },
    },
    site: {
      code: {
        empty: 'The control site code should not be empty.',
        length: 'The control site code must contain between 1 and 10 characters.',
        exists: 'The code you entered is already used for another control site.'
      },
      name: {
        empty: 'The name of the control site should not be empty.',
        length: 'The name of the control site must contain between 1 and 50 characters.'
      },
      french_description: {
        length: 'The french description of the control site must contain a maximum of 255 characters.'
      },
      english_description: {
        length: 'The english description of the control site must contain a maximum of 255 characters.'
      },
      address: {
        empty: 'The address of the control site should not be empty.'
      },
      phone_number: {
        length: 'The phone number of the control site must contain a maximum of 50 characters.'
      },
      timezone: {
        empty: 'The time zone of the control site should not be empty.',
        length: 'The time zone of the control site must contain between 1 and 10 characters.',
        invalid: 'The time zone you entered is invalid.'
      },
      cluster: {
        empty: 'The cluster of the control site should not be empty.',
        length: 'The cluster of the control site must contain between 1 and 255 characters.'
      },
      delete: {
        offices: 'The control site cannot be deleted because at least one office is associated with it.'
      }
    },
    roaming_team: {
      name: {
        blank: 'The name of the roaming team should not be empty.',
        length: 'The name of the roaming team must contain between 1 and 30 characters.',
        exists: 'The name you entered is already used for another roaming team.'
      },
      planning: {
        empty: 'The roaming team must have availability schedules.',
      },
      availability_start_date: {
        empty: 'The roaming team must have a start date for availability.',
      },
      availability_end_date: {
        empty: 'The roaming team must have a end date for availability.',
      },
      invalid_dates: 'Availability dates are invalid.',
      delete: {
        appointments: 'The roaming team cannot be deleted because at least one appointment is scheduled.'
      }
    },
    roaming_team_day_planning: {
      availability_start_time: {
        empty: 'A start time cannot be empty.'
      },
      availability_end_time: {
        empty: 'A end time cannot be empty.'
      },
      invalid_hours: 'Availability hours are invalid.'
    },
    lineid: {
      requestDateId: {
        exists: 'Line id already exists for another line.',
        empty: 'The line id should not be empty.',
        length: 'The identifier must contain at least 1 characters',
      },
      stakeholderId: {
        empty: 'The stakeholder id should not be empty.',
        deactivate: 'This stakeholder is disabled',
      },
      requestDate: {
        empty: 'The request date should not be empty.'
      },
      licencePeriod: {
        empty: 'The licence period should not be empty.',
        length: 'The licence period must contain maximum 125 characters.',
        invalid: 'The licence period type is unknown.'
      },
      startDate: {
        empty: 'The start date should not be empty.'
      },
      endDate: {
        empty: 'The end date should not be empty.'
      },
      spectrumService: {
        empty: 'Spectrum service should not be empty.',
        length: 'The spectrum service must contain maximum 125 characters.'
      },
      spectrumServiceOther: {
        length: 'Other spectrum service must contain maximum 256 characters.'
      },
      mainVenue: {
        empty: 'The main venue should not be empty.',
        length: 'The main venue must contain maximum 256 characters.'
      },
      otherVenues: {
        length: 'The other venues venue must contain maximum 256 characters.'
      },
      specificLocation: {
        length: 'The specific location venue must contain maximum 256 characters.'
      },
      usageType: {
        empty: 'The usage type should not be empty.',
        length: 'The usage type must contain maximum 125 characters.',
        invalid: 'The usage type is unknown.'
      },
      duplex: {
        empty: 'Duplex should not be empty.'
      },
      tuningRangeFrom: {
        empty: 'The tuning range from should not be empty.',
        invalid: 'The tuning range from must be between 1 and 999999.'
      },
      tuningRangeTo: {
        empty: 'The tuning range to should not be empty.',
        invalid: 'The tuning range to must be between 1 and 999999.'
      },
      channelBandwidth: {
        empty: 'The channel bandwidth should not be empty.',
        invalid: 'The channel bandwidth must be between 0 and 999999.'
      },
      tuningStep: {
        empty: 'The tuning step should not be empty.',
        invalid: 'The tuning step must be between 1 and 999999.'
      },
      transmissionPower: {
        empty: 'The transmission power should not be empty.',
        invalid: 'The transmission power must be between 0 and 999999.'
      },
      numberEquipment: {
        empty: 'The number of similar equipment should not be empty.',
        invalid: 'The number of similar equipment must be between 1 and 999999.'
      },
      manufacturer: {
        length: 'The manufacturer must contain maximum 125 characters.'
      },
      equipmentReference: {
        length: 'The equipment reference must contain maximum 125 characters.'
      },
      antennaReference: {
        length: 'The antenna reference must contain maximum 125 characters.'
      },
      satelliteName: {
        length: 'The satellite name must contain maximum 125 characters.'
      },
      antennaHalfPowerAngle: {
        length: 'The antenna half power angle must contain maximum 125 characters.'
      },
      antennaHeightAboveGround: {
        empty: 'The antenna height should not be empty.',
        invalid: 'The antenna height must be between 0 and 999999.'
      },
      antennaDiameter: {
        invalid: 'The antenna diameter must be between 0 and 999,99.'
      },
      standardTechnology: {
        length: 'The standard/technology must contain maximum 256 characters.'
      },
      wirelessLanSsid: {
        length: 'The wireless lan SSID must contain maximum 256 characters.'
      },
      wirelessLanMacAddress: {
        length: 'The wireless lan MAC address must contain maximum 256 characters.'
      },
      remarks: {
        length: 'The remarks must contain maximum 1024 characters.'
      },
      duplexHigh: {
        empty: 'The attributed frequency or channel (Simplex/Duplex High) should not be empty.',
        length: 'The attributed frequency or channel (Simplex/Duplex High) must contain maximum 125 characters.'
      },
      duplexLow: {
        empty: 'The attributed frequency (Duplex Low) should not be empty.',
        length: 'The attributed frequency (Duplex Low) must contain maximum 125 characters.'
      },
      status: {
        empty: 'The status should not be empty.',
        length: 'The status must contain maximum 125 characters.'
      },
      date: {
        invalid: 'The end date cannot be before the start date.',
      },
      agent: {
        forbiddenfields: 'An agent is not allowed to modify all fields.',
      },
      delete: {
        associated: 'A line id is linked to a control.',
      }
    },
    stakeholder: {
      id: {
        empty: 'The stakeholder id should not be empty.',
        exists: 'Stakeholder id already exists for another account.',
      },
      name: {
        empty: 'The name should not be empty.',
      },
    },
    barcode: {
      exists: 'The barcode already exists.',
      notfound: 'The barcode is not associated with any control.',
    },
    immediatetagging: {
      date: {
        empty: 'The date should not be empty.',
      },
      user: {
        empty: 'The user should not be empty.',
        invalidrole: 'The user must be a contact.',
      },
      mainvenue: {
        empty: 'The main venue should not be empty.',
        invalid: 'The main venue is invalid.',
      }
    },
    venue: {
      code: {
        empty: 'The code of the venue should not be empty.',
        length: 'The code of the venue must contain a maximum of 255 characters.',
      },
      frenchWording: {
        empty: 'The french wording of the venue should not be empty.',
        length: 'The french wording of the venue must contain a maximum of 255 characters.'
      },
      englishWording: {
        empty: 'The english wording of the venue should not be empty.',
        length: 'The english wording of the venue must contain a maximum of 255 characters.'
      },
      address: {
        empty: 'The address of the venue should not be empty.'
      },
      timeZone: {
        empty: 'The time zone of the venue should not be empty.',
        length: 'The time zone of the venue must contain a maximum of 255 characters.',
        invalid: 'The time zone you entered is invalid.'
      },
      delete: {
        data: 'The venue is linked to data and cannot be deleted.'
      }
    },
    maxBarcode : 'The limit in a range is 1000',
    start : {
      empty : 'Start of range must not be empty',
    },
    end: {
      empty: 'End of range must not be empty'
    },
    contact: {
      firstname: {
        empty: 'The firstname should not be empty',
        length: 'The contact firstname must contain maximum 100 characters',
      },
      lastname: {
        empty: 'The lastname should not be empty',
        length: 'The contact lastname must contain maximum 100 characters',
      },
      profession: {
        empty: 'The profession should not be empty',
        length: 'The contact profession must contain maximum 100 characters',
      },
      company: {
        length: 'The contact company must contain maximum 255 characters',
      },
      email:{
        regex: 'The contact email must validate the Unicode or Non-Latin email address regex',
      },
      phonenumber: {
        empty: 'The phone number should not be empty',
        length: 'The phone number must contain maximum 50 characters',
      }
    },
    address: {
      name: {
        empty: 'The address name should not be empty',
      },
      postcode: {
        empty: 'The post code should not be empty',
        length: 'The post code must contain maximum 10 characters'
      },
      city: {
        empty: 'The city name should not be empty'
      },
      country: {
        empty: 'The country should not be empty'
      },
      longitude: {
        empty: 'The longitude should not be empty'
      },
      latitude: {
        empty: 'The latitude should not be empty'
      }
    },
    specialrequest:{
        id: {
          empty: 'The specialrequest id should not be empty',
          invalid: 'The specialrequest id should not be set with invalid value',
        },
        specialrequestcontact: {
          empty: 'The special request contact information should not be empty',
        },
        contact: {
          empty: 'The contact information should not be empty',
        },
        reasonrequest: {
          empty: 'The reason for the special request should not be empty',
          undefined: 'The reason for the special request should be available value'
        },
        localizingmaterials: {
          empty: 'The localizing materials should not be empty',
          undefined: 'The localizing materials should be available value'
        },
        detailsotherlocalizingmaterials: {
          empty: 'The details other localizing materials should not be empty',
        },
        vehiculetype: {
          empty: 'The vehicule type should not be empty',
          undefined: 'The vehicule type should be available value'
        },
        detailsothervehiculetype: {
          empty: 'The detail other vehicule type should not be empty',
        },
        equipmentsspecialrequests: {
          empty: 'The equipments special requests should not be empty',
        },
        startingavailabilitydatetime: {
          empty: 'The starting availability date and time should not be empty',
        },
        endingavailabilitydatetime: {
          empty: 'The ending availability date and time should not be empty',
          endingbeforestarting: "The ending availability date can't be before the starting availability date"
        },
        wishedmeetingaddress: {
          empty: 'The wished meeting address should not be empty',
        },
        creationdate: {
          empty: 'The creation date should not be empty',
        },
        status: {
          empty: 'The status should not be empty',
          invalid: "The status isn't in the right state of workflow to make this action",
        },
        answer: {
          empty: 'The answer should not be empty',
          notempty: 'The answer should not be set as long as the request is ongoing.',
          toolong: 'The answer must contain maximum 1024 characters'
        },
        request:{
          notfound: 'The special request not found'
        }
    }
  },
  entity: {
    user: {
      id: 'ID',
      user: 'User',
      name: 'Name',
      firstname: 'Firstname',
      lastname: 'Lastname (Family name)',
      email: 'Email address',
      stakeholderId: 'Stakeholder ID',
      company: 'Company',
      phoneNumber: 'Phone number',
      activated: 'Activated',
      approved: 'Approved',
      role: 'Role',
      yubekey: 'Yubekey',
      approver: 'Account approver',
      approvalDate: 'Approval date',
      rejectMessage: 'Reject message',
      roles: {
        CONTACT_ROLE: 'Contact',
        AGENT_ROLE: 'Agent',
        ADMIN_ROLE: 'Administrator',
        contact: 'Contact',
        agent: 'Agent',
        admin: 'Administrator',
        approver: 'Account approver'
      },
      approvefilter: {
        all: 'All',
        toapprove: 'Pending',
        approved: 'Approved',
        notapproved: 'Not approved'
      }
    },
    appointment: {
      date: 'Date',
      day: 'Day',
      start: 'Start time',
      end: 'End time',
      duration: 'Duration',
      appointmentTime: 'Appointment time',
      office: 'Desk',
      roamingTeam: 'Roaming team',
      status: 'Status',
      statuses: {
        pending: 'Pending',
        honored: 'Honored',
        canceled: 'Canceled',
        no_show: 'No show',
      },
    },
    lineId: {
      requestId: 'Request ID',
      stakeholderId: 'Stakeholder ID',
      requestDate: 'Request date',
      licencePeriod: 'Licence period',
      listLicencePeriods: 'Licence periods',
      startDate: 'Authorisation start',
      endDate: 'Authorisation end',
      spectrumService: 'Spectrum service',
      spectrumServiceOther: 'Spectrum service others',
      mainVenue: 'Main venue',
      listMainVenues: 'List of main venues',
      otherVenues: 'Other venues',
      specificLocation: 'Localisation',
      usageType: 'Usage type',
      duplex: 'Duplex',
      tuningRangeFrom: 'Tuning range from (MHz)',
      tuningRangeTo: 'Tuning range to (MHz)',
      channelBandwidth: 'Channel bandwidth (kHz)',
      tuningStep: 'Tuning step (kHz)',
      transmissionPower: 'Transmission power (mW)',
      manufacturer: 'Manufacturer',
      equipmentReference: 'Equipment reference',
      numberOfEquipment: 'Number of equipment using the same frequency',
      antennaReference: 'Antenna reference',
      satelliteName: 'Satellite name',
      antennaHalfPowerAngle: 'Antenna half power angle (degrees)',
      antennaDiameter: 'Antenna diameter (m)',
      antennaHeightAboveGround: 'Antenna height above ground (m)',
      standardTechnology: 'Standard / Technology',
      wirelessLanSsid: 'Wireless LAN SSID',
      wirelessLanMacAddress: 'Wireless LAN MAC address',
      remarks: 'Remarks',
      duplexHigh: 'Attributed Frequency or Channel (Simplex/Duplex High) ',
      duplexLow: 'Attributed Frequency (Duplex Low)',
      status: 'Status',
      associated: 'Associated',
      notassociated: 'Not associated',
      usageTypes: {
        'Air to Ground': 'Air to Ground',
        'Ground to Air': 'Ground to Air',
        'Ground to Ground': 'Ground to Ground',
        'Air to Air': 'Air to Air'
      },
      licencePeriods: {
        'Olympic': 'Olympic',
        'Olympic Opening Ceremony': 'Olympic opening ceremony',
        'Olympic Closing Ceremony': 'Olympic closing ceremony',
        'Paralympic': 'Paralympic',
        'Paralympic Opening Ceremony': 'Paralympic opening ceremony',
        'Paralympic Closing Ceremony': 'Paralympic closing ceremony'
      },
      statusOptions: {
        approved: 'Approved',
        refused: 'Refused',
      },
      duplexOptions: {
        true: 'Yes',
        false: 'No',
      },
    },
    stakeholder: {
      name: 'Company name',
      stakeholderId: 'Stakeholder ID',
    },
    office: {
      office: 'Desk',
      name: 'Name',
      site: 'Site',
      enabled: 'Enabled',
      disabled: 'Disabled',
      state: 'State',
      openDate: 'Open date',
      openCloseDate: 'Opening and closing dates',
      closeDate: 'Close date',
      planning: 'Planning',
    },
    roamingTeam: {
      name: 'Name',
      active: 'Active',
      inactive: 'Inactive',
      state: 'State',
      availabilityStartDate: 'Availability start date',
      availabilityEndDate: 'Availability end date',
      planning: 'Availability hours',
      availabilityDates: 'Availability dates'
    },
    planning: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      morning: 'Morning',
      afternoon: 'Afternoon',
      from: 'From',
      to: 'to',
      enabled: 'Enabled',
    },
    site: {
      site: ' Control site',
      code: 'Code',
      name: 'Name',
      french_description: 'French description',
      english_description: 'English description',
      address: {
        field: 'Address',
        name: 'Name',
        country: 'Country',
        postcode: 'Postcode',
        city: 'City',
      },
      phone_number: 'Phone number',
      timezone: 'Timezone',
      cluster: 'Cluster',
      enabled: 'Enabled',
      disabled: 'Disabled'
    },
    barcode: {
      list: 'Barcode list',
      code: 'Code',
      start: 'Tag range start',
      deleted: 'Deleted',
      content: 'Are you sure you want to delete this barcode ?',
      end: 'Code number',
      creationDate: 'Creation date',
      from : 'From',
      fromLowercase : 'from',
      to : 'to',
      user : 'Agent'
    },
    control: {
      associated: 'Associated',
      creation: 'Creation',
      deletion: 'Deletion',
      disassociationDate: 'Disassociation date',
      associationDate:'association date',
      disassociationDetails:'Disassociation details',
      associationUser: 'Agent (association)',
      disassociationUser: 'Agent (disassociation)',
      user: 'User',
      disassociation: 'Disassociation',
    },
    specialrequest: {
      specialrequest: 'Special request',
      message: 'Please manually enter the different types of equipment to be checked, their number, the desired address for the appointment, your availability as well as all the elements that you deem relevant to communicate to us.',
      answer: 'Answer',
      status: 'Status',
      statusOptions: {
        PENDING: 'Pending',
        REJECTED: 'Rejected',
        ACCEPTED: 'Accepted',
      },
      reasons: {
        localizingmaterials: 'Equipment stored at a fixed location',
        materialsinvehicle: 'On board equipment inside vehicle'
      },
      materialLocalisations: {
        warehouse: 'Stored in a warehouse or premises (off-site)',
        onsite: 'Present at the event venue',
        other: 'Other location — please specify :'
      },
      vehicleTypes: {
        outsidebroadcastvan: 'Outside Broadcast Van',
        sngvehicle: 'SNG Vehicle',
        car: 'Car',
        motorbike: 'Motorbike',
        plane: 'Plane',
        helicopter: 'Helicopter',
        boat: 'Boat',
        drone: 'Drone',
        other: 'Other',
      },
      reasonRequest: 'Reason for the special request',
      localizingMaterials: 'Specify the equipment location',
      detailsOtherLocalizingMaterials: 'Other localizing materials',
      vehicleTypesLabel: 'Vehicle types',
      detailsOtherVehiculeType: 'Other vehicle type',
      commentary: 'Commentary',
      availabilityDatetime: 'Available date time',
      startAvailabilityDatetime: 'Start',
      endAvailabilityDatetime: 'End',
      wishedMeetingAddress: 'Wished meeting address',
      specialRequestContact: {
        lastName: 'Lastname',
        firstName: 'FIrstname',
        profession: 'Profession',
        company: 'Company',
        phoneNumber: 'Phone number',
        email: 'Email',
      }
    },
    equipmentType: {
      code: 'Code',
      frenchWording: 'French label',
      englishWording: 'English label',
      field : {
        type: 'Type',
        quantity: 'Quantity',
        placeholderType: 'Select',
        placeholderQuantity: 'Enter quantity'
      }
    },
    venue: {
      id: 'id',
      code: 'Code',
      frenchWording: 'French label',
      englishWording: 'English label',
      address: 'Address',
      timeZone: 'Time zone'
    }
  },
  nav: {
    home: 'Home',
    dummy: 'Dummy',
    user: 'Users',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    site: 'Control sites',
    office: 'Desks',
    roamingTeam: 'Roaming teams',
    stakeholder: 'Stakeholders',
    lineId: 'Assigned frequencies',
    createAppointment: 'Create an appointment',
    immediateTagging: 'Immediate tagging',
    createImmediateTagging: 'Create an immediate tagging',
    appointments: 'Planned tagging',
    specialrequest: 'Special request',
    specialrequests: 'Special requests',
    barcodeControl: 'Request search',
    myappointments: 'My appointments',
    userDetail: 'User detail',
    userTagHistory: 'User tag history',
    officeDetail: 'Office details',
    appointmentDetail: 'Appointments details',
    immediateTaggingSummary: 'Summary of immediate tagging',
    immediateTaggingDetail: 'Immediate tagging details',
    tag: 'Tags',
    userProfile: 'You are logged in as',
    equipmentType : 'Equipment types',
    roamingTeamDetail: 'Roaming team details',
    siteDetail: 'Site details',
    venue: 'Venues',
    settings: 'Settings'
  },
  action: {
    crud: {
      create: 'Create',
      import: 'Import',
      export: 'Export',
      exportCsv: 'Export to CSV',
      importCsv: 'Import from CSV',
      read: 'Show',
      update: 'Update',
      delete: 'Delete',
    },
    reset: 'Reset',
    extend: 'Extend',
    collapse: 'Collapse',
    sendSummary: 'Send request summary',
    search: 'Search',
    add: 'Add',
    scan: 'Scan',
    associate: 'Associate',
    overview: 'Overview',
    yes: 'Yes',
    no: 'No',
    back: 'Go back',
    confirm: 'Validate',
    reject: 'Reject',
    details: 'Details',
    cancel: 'Cancel',
    at: 'at',
    by: 'by',
    visualize: 'Visualize',
    filter: {
      all: 'All'
    }
  },
  legacynoticepage: legacynotice,
  gcupage: gcu,
  loginpage: {
    input: {
      email: 'Email address',
      password: 'Password',
      login: 'Login',
      resetpassword: 'I forgot my password',
    },
    captcha: {
      title: 'Security check : please select the correct answer to continue.',
      waiting: 'Please wait while the security test is loading...',
      placeholder: 'Enter the captcha',
    },
  },
  resetpasswordpage: {
    title: 'Reset my password',
    input: {
      email: 'Email address',
      reset: 'Reset',
      information:
        'An email containing the password reset procedure will be sent to you if we have an account matching your email address.',
    },
  },
  changepasswordpage: {
    title: 'Change my password',
    input: {
      password: 'Password',
      passwordConfirmation: 'Confirm password',
      change: 'Change password',
    },
    expired: {
      message:
        'This link has expired. Click below to return to the home page :',
      home: 'Return to the home page',
    },
    success: 'The password has been correctly changed.',
  },
  registerpage: {
    fieldset: {
      stakeholder: 'Stakeholder Id',
      contact: 'Contact',
    },
    input: {
      stakeholder: 'Id',
      lastname: 'Lastname (Family name)',
      firstname: 'Firstname',
      company: 'Company',
      email: 'Email address',
      emailConfirmation: 'Email address confirmation',
      phoneNumber: 'Phone number',
      password: 'Password',
      confirm_password: 'Confirm Password',
      register: 'Register',
    },
    messages: {
      success: 'Registration saved. Please check your email for confirmation.',
      approval: 'Registration saved. It is currently pending approval.'
    },
    captcha: {
      title: 'Security check : please select the correct answer to continue.',
    },
  },
  userdetailpage: {
    fieldset: {
      stakeholder: 'Stakeholder',
      contact: 'Contact',
      account: 'Account',
    },
    role: 'Role',
    account: {
      state: 'State',
      activate: 'Activate',
      desactivate: 'Desactivate',
    },
    roles: {
      contact: 'Contact',
      agent: 'Agent',
      admin: 'Administrator',
    },
    approved: 'Approved account',
    showappointments: 'Show appointments',
  },
  taghistorypage: {
    title: 'Tag history',
  },
  activationPage: {
    success: 'Your account is now activated, please log in.',
    failed: 'Could not activate the account, please try again later.',
    backtohome: 'Back to home.',
  },
  userpage: {
    nouser: 'No user to show.',
    createUser: 'Add user',
    accountToApprove: 'Account to approve',
    createSuccess: 'User successfully created.',
    updateUser: 'Update user',
    updateSuccess: 'User successfully updated.',
    form: {
      role: {
        placeholder: 'Select role',
      },
      stakeholdersApprover: 'Stakeholders approvables (leave empty for no constraint)'
    },
    locked: 'Locked',
    title: {
      detail: 'View user profile',
      delete: 'Deleter user',
      reject: 'Reject approval',
      approve: 'Approve user'
    },
    dialog: {
      delete: {
        header: 'Delete confirmation',
        content: 'Are you sure you want to delete this user ?',
      },
      activate: {
        header: 'Confirm activation',
        content: 'Are you sure you want to activate this user ?',
      },
      deactivate: {
        header: 'Confirm deactivation',
        content: 'Are you sure you want to deactivate this user ?',
      },
      reject: {
        header: 'Reject confirmation',
        content: 'Are you sure you want to reject this approval',
        message: 'Reject message :'
      },
      approval: {
        header: 'Approval confirmation',
        content: 'Are you sure you want to approve this user ?',
      },
      abortButton: 'Cancel',
      rejectButton: 'Reject',
      confirmButton: 'Validate',
    },
    toast: {
      activate: {
        success: 'User activated',
        error: 'Problem in the activating',
      },
      deactivate: {
        success: 'User deactivate',
        error: 'Problem in the deactivation',
      },
      delete: {
        success: 'User deleted',
        error: 'Problem in the deleting',
      },
      approval: {
        success: 'User approved',
        reject: 'Approval rejected'
      }
    },
    appointment: 'See his appointments',
  },
  appointmentPage: {
    noOffice: 'No office available',
    noRoamingTeam: 'No roaming team available',
    control: {
      estimatedDuration: 'Estimated control duration:',
      effectiveDuration: 'Real time :',
    },
    appointments: {
      sectionTitle: 'Appointment appointments selection',
      selectInstruction:
        'Please select one or more appointment appointments from the following desks:',
      duration: 'duration',
      selectedAppointments: 'Selected appointment appointments:',
      noSelectedAppointment:
        'No seleted appointments. Use the calendars above to select appointments.',
      removeAppointment: 'Remove this appointment',
      validateAppointments: 'Validate these appointments',
      remainingTime: 'Remaining time :',
      editDialogHeader: 'Edit appointment',
      searchByDate: 'Search by date:',
      noOffice: 'No office available',
    },
    equipment: {
      equipmentNumberInstruction: 'Enter the number of equipment to control :',
      equipmentType: 'Type of equipment :',
      equipmentNumber: 'Number of equipment ',
      equipments: 'equipment(s)',
      defaultEquipment: 'I don\'t know',
    },
    toast: {
      validate: 'Your appointment has been registered !',
      deleted: 'Your appointment has been cancelled',
    },
  },
  stakeholderpage: {
    create: 'Add stakeholder',
    update: 'Update stakeholder',
    validation: 'Add stakeholder',
    locked: 'Locked',
    messages: {
      createSuccess: 'The stakeholder has been added !',
      updateSuccess: 'The stakeholder has been updated !',
    },
    dialog: {
      activate: {
        header: 'Confirm activation',
        content: 'Are you sure you want to activate this stakeholder ?',
      },
      deactivate: {
        header: 'Confirm deactivation',
        content: 'Are you sure you want to deactivate this stakeholder ?',
      },
      abortButton: 'Cancel',
      confirmButton: 'Validate',
    },
    toast: {
      activate: {
        success: 'Stakeholder activated',
        error: 'Problem in the activating',
      },
      deactivate: {
        success: 'Stakeholder deactivate',
        error: 'Problem in the deactivation',
      },
    },
    tooltip: {
      delete: 'Delete the stakeholder',
    },
  },
  lineidpage: {
    create: 'Create line id',
    update: 'Update line id',
    import: 'Import PMSE Audio',
    createSuccess: 'Line id successfully created.',
    updateSuccess: 'Line id successfully updated.',
    delete: 'Delete selection',
    extractactivity: 'Activity indicators',
    advancedFilters: 'Advanced filters',
    tagmanagement: 'Tag management',
    associationsHistory: 'History of associations',
    fieldset: {
      information: 'Informations',
      location: 'Location',
      frequency: 'Line specifications',
      equipment: 'Equipment specifications',
      antenna: 'Antenna specifications',
      wifi: 'Wifi specifications',
      tnt: 'Test & Tagging'
    },
    dropdown: {
      status: 'Select a status',
      location: 'Select a location',
      licencePeriod: 'Select a period',
      usageTypes: 'Select a usage type'
    },
    dialog: {
      import: {
        header: 'Line Id import form',
        uploadlabel: 'Choose a file to import (csv format with header, column separated with ";").',
        error: 'An error occured during the import, please try later.',
        invalid: 'The import failed, an email has been sent to you with the details.',
        success: 'Line ids successfully imported.',
      },
      delete: {
        header: 'Delete confirmation',
        content: 'Are you sure you want to delete this line id ?',
      },
      deletemultiple: {
        header: 'Delete confirmation',
        content: 'Are you sure you want to delete these lines id?',
      },
      abortButton: 'Cancel',
      confirmButton: 'Validate',
    },
    tooltip: {
      detail: 'See the line id request',
      delete: 'Delete line id'
    },
    toast: {
      delete: {
        success: 'Line id deleted',
        error: 'Problem in the deleting',
      },
      deletemultiple: {
        success: 'Lines id deleted',
        error: 'Problem in the deleting',
      },
    },
  },
  officepage: {
    title: {
      delete: 'Delete the desk',
      detail: 'Show the desk',
    },
    createOffice: 'Create a desk',
    updateOffice: 'Modify a desk',
    dialog: {
      enable: {
        header: 'Confirm activation',
        content: 'Are you sure you want to enable this desk ?',
      },
      disable: {
        header: 'Confirm deactivation',
        content: 'Are you sure you want to disable this desk ?',
      },
      delete: {
        header: 'Delete confirmation',
        content: 'Are you sure you want to delete this desk ?',
      },
      appointment: {
        header: 'Invalid action',
        content: 'A desk cannot be deleted if it has scheduled appointments.',
      },
      abortButton: 'Cancel',
      confirmButton: 'Validate',
    },
    toast: {
      enable: 'Desk enabled successfully',
      disable: 'Desk disabled successfully',
      delete: 'Desk deleted successfully',
      updateSuccess: 'Desk updated successfully',
      createSuccess: 'Desk created successfully',
    },
  },
  officedetailpage: {
    fieldset: {
      site: 'Site',
      office: 'Desk',
    },
    delete: 'Desk deleted successfully',
  },
  sitesection: {
    title: 'Selection of a control site',
    subtitle: 'Please select a control site from those listed below.',
    quick_select: 'Quick selection',
    site: {
      title: 'Selected control site:',
      button: 'Make an appointment',
    },
    dropdown: 'Select a control site',
  },
  appointmentrecap: {
    title: 'SUMMARY OF THE APPOINTMENT PROCESS',
    subtitle:
      'Please verify your appointment information and certify the accuracy of the information.',
    fieldset: {
      stakeholder: 'Stakeholder',
      equipment: 'Equipments',
      site: 'Control site',
      appointment: 'Appointment',
    },
    quantity: 'Quantity',
    conditions: 'I accept the terms and conditions.',
    validate: 'Validate my appointment',
    dialog: {
      conditions: {
        header: 'General terms and conditions of use',
        content: '',
      },
      abortButton: 'Cancel',
      confirmButton: 'Validate',
    },
  },
  appointmentspage: {
    title: 'Planned tagging',
    searchbarcode: 'Please enter or scan a barcode',
    noappointmentfound: 'No appointment found',
  },
  userappointmentspage: {
    title: 'Appointments',
    tab: {
      upcoming: 'Upcoming appointments',
      all: 'All appointments',
      immediatetagging: 'Immediate tagging',
    },
    createappointment: 'Create an appointment'
  },
  appointmentdetailspage: {
    barcodes: 'barcodes associated',
    equipmentNumber: 'Number of equipments to be tagged :',
    equipmentTaggedNumber: 'Number of tagged equipments :',
    dialog: {
      addbarcode: {
        title: 'Barcode scanning',
      },
    },
    toast: {
      summarySuccess: 'Summary has been send successfully',
    },
  },
  specialrequestcreatePage: {
    title: 'Special request',
    toast: {
      success: 'Your request has been sent',
    },
    generalinformations: 'General informations',
    sitecontact: 'On-site contact'
  },
  specialrequestupdatePage: {
    title: 'Special request validation',
    details: 'Request details',
    contactOnSite: 'On-site contact',
    alreadyAnswered: 'This request has already been answered',
    toast: {
      success: 'Your response has been sent',
    }
  },
  specialrequest:{
    id: {
      notfound: "The specialrequest identification doesn't found"
    },
    txt_info:
      'The estimated inspection time is more than 3 hours. We invite you to make your request for an appointment in writing. You will be contacted as soon as possible .'
  },
  specialRequestPage: {
    startingAvailabilityDatetime: 'Availability start date',
    endingAvailabilityDatetime: 'Availablility end date',
    city: 'City',
    postcode: 'Postcode '
  },
  equipmentTypePage: {
    createEquipmentType: 'Create equipment type',
    code: 'Code',
    frenchWording: 'French label',
    englishWording: 'English label',
    createSuccess: 'Equipment type successfully created.',
    updateEquipmentType: 'Edit equipment type',
    updateSuccess: 'Equipment type successfully edited.',
    toast: {
      delete: {
        success: 'Equipment type deleted',
        error: 'Error when deleting',
      }
    },
    dialog: {
      delete: {
        header: 'Delete confirmation',
        content: 'Are you sure you want to delete this equipment type ?',
        abortButton: 'Cancel',
        confirmButton: 'Validate',
      }
    }
  },
  venuePage: {
    venue: 'Venues',
    code: 'Code',
    address: 'Address',
    timeZone: 'Time zone',
    active: 'Active',
    createVenue: 'Create a venue',
    updateVenue: 'Update a venue',
    createSuccess: 'Venue created',
    updateSuccess: 'Venue updated',
    toast: {
      delete: {
        success: 'Venue deleted',
        error: 'Error when deleting',
      },
      activate: {
        success: 'Venue activated',
        error: 'Error when activating',
      },
      deactivate: {
        success: 'Venue deactivated',
        error: 'Error when deactivating',
      }
    },
    dialog: {
      delete: {
        header: 'Delete confirmation',
        content: 'Are you sure you want to delete this venue ?',
        abortButton: 'Cancel',
        confirmButton: 'Validate',
      },
      activate: {
        header: 'Activation confirmation',
        content: 'Are you sure you want to activate this venue ?',
        abortButton: 'Cancel',
        confirmButton: 'Validate',
      },
      deactivate: {
        header: 'Deactivation confirmation',
        content: 'Are you sure you want to deactivate this venue ?',
        abortButton: 'Cancel',
        confirmButton: 'Validate',
      }
    }
  },
  venueDetailPage: {
    title: 'Venue details',
    venue: 'Venue'
  },
  settingsPage: {
    title: 'Application settings',
    eventData: 'Event data',
    exportEventData: 'Export event data',
    deleteEventData: 'Delete event data',
    toast: {
      delete: {
        in_progress: 'Data deletion in progress',
        success: 'Event data successfully deleted'
      }
    },
    dialog: {
      delete: {
        content: 'Are you sure you want to delete the event data? This action is irreversible.',
        confirmButton: 'Confirm',
        abortButton: 'Abort'
      }
    }
  },
  dialog: {
    appointmentdetails: {
      title: 'Appointment overview',
      details: 'Details',
    },
    deleteappointment: {
      title: 'Appointment cancellation',
      content: 'Please confirm the cancellation of the appointment.',
      toast: {
        delete: 'Appointment cancelled successfully',
      },
    },
    barcodeform: {
      title: 'Tag range creation',
      toast: {
        success: 'Range successfully created',
        error: 'Problem in creating'
      }
    },
    detailbarcode: {
      title: 'Tag range detail',
    },
    editbarcode: {
      title: 'Edit tag range detail',
      subtitle: 'Please select the assigned frequencies associated with the tag range.',
      message: {
        title : 'Confirmation',
        content1: 'The barcode(s)',
        content2: 'will no longer be associated with any assigned frequencies',
      },
      togglecontrolsuccess: 'The barcode has been successfully modified',
    },
    deletebarcode: {
      title: 'Delete tag range',
      content: 'Deleting a tag range will delete all associated line Ids.'
    }
  },
  roamingteampage: {
    create: 'Create a roaming team',
    update: 'Update a roaming team',
    title: {
      detail: 'Show the roaming team',
      delete: 'Delete the roaming team'
    },
    dialog: {
      enable: {
        header: 'Activation confirmation',
        content: 'Are you sure you want to enable this roaming team ?'
      },
      disable: {
        header: 'Deactivation confirmation',
        content: 'Are you sure you want to deactivate this roaming team?'
      },
      delete: {
        header: 'Delete confirmation',
        content: 'Are you sure you want to delete this roaming team?',
      },
      abortButton: 'Cancel',
      confirmButton: 'Validate'
    },
    toast: {
      createSuccess: 'Roaming team successfully created',
      updateSuccess: 'Roaming team successfully updated',
      enableSuccess: 'Roaming team successfully activated',
      disableSuccess: 'Roaming team successfully deactivated',
      deleteSuccess: 'Roaming team successfully deleted'
    }
  },
  roamingteampagedetailpage: {
    fieldset: {
      roamingteam: 'Roaming team',
    }
  },
  sitepage: {
    create: 'Create a control site',
    update: 'Update a control site',
    title: {
      detail: 'Show the control site',
      delete: 'Delete the control site'
    },
    dialog: {
      enable: {
        header: 'Activation confirmation',
        content: 'Are you sure you want to enable this control site and the associated offices?'
      },
      disable: {
        header: 'Deactivation confirmation',
        content: 'Are you sure you want to deactivate this control site and the associated offices?'
      },
      delete: {
        header: 'Delete confirmation',
        content: 'Are you sure you want to delete this control site?',
      },
      abortButton: 'Cancel',
      confirmButton: 'Validate'
    },
    toast: {
      createSuccess: 'Control site successfully created',
      updateSuccess: 'Control site successfully updated',
      enableSuccess: 'Control site successfully activated',
      disableSuccess: 'Control site successfully deactivated',
      deleteSuccess: 'Control site successfully deleted'
    }
  },
  sitedetailpage: {
    fieldset: {
      site: 'Control site',
      address: 'Address'
    }
  },
  stakeholderselection: {
    title: 'Select or create a stakeholder',
    stakeholder: 'Stakeholder',
    select: 'Select',
    or: 'OR',
    new: 'New stakeholder'
  },
  userselection: {
    title: 'Select or create a contact',
    user: 'Contact',
    select: 'Select',
    or: 'OR',
    new: 'New contact',
    not_activated: 'The email address is associated with a contact account not active.',
    resend_activation_link: 'Resend the activation link by email',
    resend_success: 'Activation email successfully resent'
  },
  venueselection: {
    title: 'Select a venue',
    select: 'Select'
  },
  footer: {
    home: 'ANFR',
    mentionLegal: 'Legal notice',
    cgu: 'CGU',
  },
  maintenancepage: {
    unavailable: 'Service unavailable',
    subtitle: 'The app is currently undergoing maintenance.'
  },
  error: {
    global: 'An error occured',
    technical: 'A technical error occurred',
  },
  warning: {
    sessionended: 'Your session has expired, please log in again.',
  },
  primevue: {
    startsWith: 'Starts with',
    contains: 'Contains',
    notContains: 'Not contains',
    endsWith: 'Ends with',
    equals: 'Equals',
    notEquals: 'Not equals',
    noFilter: 'No Filter',
    lt: 'Less than',
    lte: 'Less than or equal to',
    gt: 'Greater than',
    gte: 'Greater than or equal to',
    dateIs: 'Date is',
    dateIsNot: 'Date is not',
    dateBefore: 'Date is before',
    dateAfter: 'Date is after',
    clear: 'Clear',
    apply: 'Apply',
    matchAll: 'Match All',
    matchAny: 'Match Any',
    addRule: 'Add Rule',
    removeRule: 'Remove Rule',
    accept: 'Yes',
    reject: 'No',
    choose: 'Choose',
    upload: 'Upload',
    cancel: 'Cancel',
    dayNames: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    monthNamesShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ],
    today: 'Today',
    weekHeader: 'Wk',
    firstDayOfWeek: 0,
    dateFormat: 'yy-mm-dd',
    weak: 'Weak',
    medium: 'Medium',
    strong: 'Strong',
    passwordPrompt: 'Enter a password',
    emptyFilterMessage: 'No results found',
    emptyMessage: 'No available options',
    aria: {
      trueLabel: 'True',
      falseLabel: 'False',
      nullLabel: 'Not Selected',
    }
  }
};
